import "./_select-asset-modal.scss";

import {useState} from "react";
import classNames from "classnames";

import {AssetListItemData} from "../../../asset/util/assetModels";
import useSearchPoolMemberAssets from "../util/hook/useSearchPoolMemberAssets";
import Modal from "../../../component/modal/Modal";
import ModalHeader from "../../../component/modal/header/ModalHeader";
import SearchInput from "../../../component/search-input/SearchInput";
import AsyncContent, {
  AsyncContentError,
  AsyncContentStatus
} from "../../../component/async-content/AsyncContent";
import SelectAssetModalList from "./list/SelectAssetModalList";
import StateMessageBox from "../../../component/state-message-box/StateMessageBox";

interface SelectAssetModalProps {
  isOpen: boolean;
  onClose: VoidFunction;
  onSelect: (asset: AssetListItemData) => void;
  assetsToFilterOut?: string[];
}

function SelectAssetModal({
  isOpen,
  onClose,
  onSelect,
  assetsToFilterOut
}: SelectAssetModalProps) {
  const [keyword, setKeyword] = useState("");

  const requestState = useSearchPoolMemberAssets({
    keyword,
    limit: 6,
    assetsToFilterOut
  });

  return (
    <Modal
      customClassName={"select-asset-modal"}
      contentLabel={"Asset Modal"}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      overlayClassName={"select-asset-modal-overlay"}
      onClose={onClose}>
      <ModalHeader
        title={"Select an asset"}
        closeButtonProps={{onClick: onClose}}
        customClassName={classNames("has-space-between", "is-vertically-centered")}
      />

      <SearchInput
        customClassName={"select-asset-modal__typeahead-input"}
        placeholder={"Search assets"}
        name={"token-search"}
        onQueryChange={setKeyword}
        value={keyword}
      />

      <AsyncContent requestStates={[requestState]} content={renderContent} />
    </Modal>
  );

  function renderContent(status: AsyncContentStatus, error: AsyncContentError) {
    let content = (
      <div className={"is-centered select-asset-modal__content"}>
        <StateMessageBox state={"loading"} message={"Assets are loading..."} />
      </div>
    );

    switch (status) {
      case AsyncContentStatus.PENDING: {
        content = (
          <div className={"is-centered select-asset-modal__content"}>
            <StateMessageBox state={"loading"} message={"Assets are loading..."} />
          </div>
        );
        break;
      }

      case AsyncContentStatus.ERROR: {
        content = (
          <div className={"is-centered select-asset-modal__content"}>
            <StateMessageBox
              state={"error"}
              message={error?.message || "Assets could not be loaded"}
            />
          </div>
        );
        break;
      }
      case AsyncContentStatus.SUCCESS: {
        if (requestState.data && requestState.data.results.length) {
          content = (
            <SelectAssetModalList
              assetList={requestState.data.results}
              onSelect={onSelect}
            />
          );
        } else {
          content = (
            <div className={"is-centered select-asset-modal__content"}>
              <StateMessageBox state={"empty"} message={"There are no matching assets"} />
            </div>
          );
        }

        break;
      }

      default:
        break;
    }

    return content;
  }
}

export default SelectAssetModal;
